import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-zinc-800 last:border-0" data-id="element-14">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full justify-between items-center py-5 text-left text-zinc-100 font-semibold hover:text-brand transition-colors" data-id="element-15">
        <span className="pr-4" data-id="element-16">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} className="text-brand shrink-0" data-id="element-17">
          <ChevronDown size={20} data-id="element-18" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-19">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-20">
            <p className="pb-5 text-zinc-400 leading-relaxed" data-id="element-21">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}